export default __webpack_public_path__ + "static/media/all-saved.f41f12e1.png";